import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200/50"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-950">
              八戒影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 7).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === "all" ? "/" : `/category/${cat.slug}`}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <div className="md:hidden flex items-center gap-3">
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === "all" ? "/" : `/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200/50 my-1"></div>
            <Link
              to="/about"
              className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line text-base"></i>
              </div>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}